<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon icon-tabler icon-tabler-mail"
    :width="props.width"
    :height="props.height"
    viewBox="0 0 24 24"
    stroke-width="2"
    stroke="currentColor"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
    <path
      d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z"
    ></path>
    <path d="M3 7l9 6l9 -6"></path>
  </svg>
</template>

<script lang="ts" setup>
export interface IconListProps {
  width?: string;
  height?: string;
}

const props = withDefaults(defineProps<IconListProps>(), {
  width: "24px",
  height: "24px",
});
</script>

<style scoped></style>
